import middleware from "./api.middleware";

export default {
  get: (url, request, options) => middleware(url, request, options, "get"),
  post: (url, request, options) => middleware(url, request, options, "post"),
  put: (url, request, options) => middleware(url, request, options, "put"),
  delete: (url, request, options) => middleware(url, request, options, "delete"),
  patch: (url, request, options) => middleware(url, request, options, "patch"),
};
